import type { TriangleElement } from '@/components/canvas/document/publicTypes';
import { elementFillCss, firstShadow, firstStroke } from '@/components/canvas/elements/model';
import { drawShapeText } from '../utils/shapeTextExport';

export async function drawTriangle(ctx: CanvasRenderingContext2D, el: TriangleElement) {
  const { x, y } = el.layout;
  const { width, height } = el.size;
  const fillColor = elementFillCss(el);
  const stroke = firstStroke(el.appearance);
  const shadow = firstShadow(el.appearance);
  const direction = el.data.direction ?? 'up';

  if (shadow) {
    ctx.shadowBlur = shadow.blur;
    ctx.shadowColor = shadow.color;
    ctx.shadowOffsetX = shadow.offsetX;
    ctx.shadowOffsetY = shadow.offsetY;
  }

  ctx.beginPath();
  if (direction === 'up') {
    ctx.moveTo(x + width / 2, y);
    ctx.lineTo(x + width, y + height);
    ctx.lineTo(x, y + height);
  } else if (direction === 'down') {
    ctx.moveTo(x, y);
    ctx.lineTo(x + width, y);
    ctx.lineTo(x + width / 2, y + height);
  } else if (direction === 'left') {
    ctx.moveTo(x + width, y);
    ctx.lineTo(x + width, y + height);
    ctx.lineTo(x, y + height / 2);
  } else {
    ctx.moveTo(x, y);
    ctx.lineTo(x + width, y + height / 2);
    ctx.lineTo(x, y + height);
  }
  ctx.closePath();

  if (fillColor) {
    ctx.fillStyle = fillColor;
    ctx.fill();
  }

  ctx.shadowBlur = 0;
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;

  if (stroke && stroke.width > 0 && stroke.color) {
    ctx.strokeStyle = stroke.color;
    ctx.lineWidth = stroke.width;
    if (stroke.style === 'dashed') ctx.setLineDash([stroke.width * 3, stroke.width * 2]);
    else if (stroke.style === 'dotted') ctx.setLineDash([stroke.width, stroke.width]);
    else ctx.setLineDash([]);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  if (el.data.text) {
    drawShapeText(ctx, el, { x, y, width, height });
  }
}
